export const authRoles = {
    sa: ['SA'],
    admin: ["SA",'ADMIN', "SUPPORT_ADMIN"],
    editor: ['SA', 'ADMIN', 'EDITOR'],
    guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'],
}